// extracted by mini-css-extract-plugin
module.exports = {"block":"ImageUpload_block__35X-b","block--circle":"ImageUpload_block--circle__2O11Z","overlay":"ImageUpload_overlay__3dsIi"};